declare global {
  interface Window {
    grecaptcha: any;
  }
}

const recaptchaLoaders = new Map<string, Promise<any>>();

export const useRecaptcha = () => {
  const loadRecaptcha = (siteKey: string) => {
    if (!siteKey) {
      return Promise.reject("reCAPTCHA anahtarı bulunamadı.");
    }

    if (typeof window === "undefined") {
      return Promise.reject("reCAPTCHA yalnızca tarayıcı ortamında çalışır.");
    }

    if (window.grecaptcha) {
      return Promise.resolve(window.grecaptcha);
    }

    if (recaptchaLoaders.has(siteKey)) {
      return recaptchaLoaders.get(siteKey)!;
    }

    const loaderPromise = new Promise<typeof window.grecaptcha>(
      (resolve, reject) => {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.defer = true;
        script.setAttribute("data-recaptcha-loader", siteKey);
        script.onload = () => {
          if (window.grecaptcha) {
            resolve(window.grecaptcha);
          } else {
            reject("reCAPTCHA yüklenemedi.");
          }
        };
        script.onerror = () => reject("reCAPTCHA script yüklenemedi.");
        document.head.appendChild(script);
      }
    ).catch((error) => {
      recaptchaLoaders.delete(siteKey);
      throw error;
    });

    recaptchaLoaders.set(siteKey, loaderPromise);
    return loaderPromise;
  };

  return { loadRecaptcha };
};
